'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _NoResultTwoTone = require('./lib/icons/NoResultTwoTone');
  
  
  var _default = _NoResultTwoTone;
  exports.default = _default;
  module.exports = _default;